import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { springBaseUrl } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../components/Footer";
import {
  saveCartEarlyCheckin,
  saveCartSettleDues,
  saveEarlyCheckinnSlot,
} from "../redux/slice/slice";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import MainSkeleton from "../skeletons/MainSkeleton";
import CheckinSkeleton from "../skeletons/CheckinSkeleton";
import HomeIcon from "@mui/icons-material/Home";
import EventNoteIcon from "@mui/icons-material/EventNote";
import moment from "moment";
import { encryptBookingId } from "../utils/CryptoHashing";

const ModifyBookingStatus = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  console.log("location", location);
  const dateFormat = (inputDate) => {
    return moment(inputDate, "DD-MM-YYYY HH:mm:ss").format("Do MMMM, YY");
  };
  const timeFormat = (inputDate) => {
    return moment(inputDate, "DD-MM-YYYY HH:mm:ss").format("h:mm a");
  };
  const navigate = useNavigate();
  const hotelId = useSelector((state) => state?.HotelId);
  const HomepageData = useSelector((state) => state?.HomepageData);
  const [loader, setLoader] = useState(false);
  const SummaryData = useSelector((state) => state?.SummaryData);
  const currencySymbol = useSelector((state) => state?.Currency);
  const HotelData = useSelector((state) => state?.HotelData);

  const [homePageDataApi, setHomePageDataApi] = useState({});
  const [summaryDataApi, setSummaryDataApi] = useState({});
  const [homePageDataLoading, setHomePageDataApiLoading] = useState(false);
  const [summaryDataApiLoading, setSummaryDataApiLoading] = useState(false);

  const gettingHomepageData = () => {
    setHomePageDataApiLoading(true);
    axios
      .get(
        `${springBaseUrl}/core/api/v1/ss/get-selfservice-homepage-data?bookingId=${encodeURIComponent(encryptBookingId(HomepageData?.booking?.bookingId))}&hash=${encodeURIComponent(localStorage.getItem("bookingHash") || '')}`
      )
      .then((data) => {
        setHomePageDataApi(data?.data);
        setHomePageDataApiLoading(false);
      })
      .catch((err) => {
        setHomePageDataApiLoading(false);
      });
  };

  const gettingsummaryData = () => {
    setSummaryDataApiLoading(true);
    axios
      .get(
        `${springBaseUrl}/core/api/v1/ss/get-selfservice-summary-data?bookingId=${encodeURIComponent(encryptBookingId(HomepageData?.booking?.bookingId))}&hash=${encodeURIComponent(localStorage.getItem("bookingHash") || '')}`
      )
      .then((data) => {
        setSummaryDataApi(data?.data);
        setSummaryDataApiLoading(false);
      })
      .catch((err) => {
        setSummaryDataApiLoading(false);
      });
  };
  useEffect(() => {
    gettingHomepageData();
    gettingsummaryData();
  }, [HomepageData]);

  const handleSettleDues = () => {
    const settleDuesObj = {};
    settleDuesObj.amountBeforeTax =
      summaryDataApi?.payment_info?.invoice_subtotal_amount;
    settleDuesObj.amountAfterTax = summaryDataApi?.payment_info?.balance_due;
    settleDuesObj.Tax = summaryDataApi?.payment_info?.total_tax_amount;
    settleDuesObj.selfCheckInPercentage =
      homePageDataApi?.booking?.selfCheckInPercentage;
    settleDuesObj.isModifyBooking = true;
    dispatch(saveCartSettleDues(settleDuesObj));
    navigate("/checkout-summary");
  };

  return (
    <>
      {loader ? (
        <CheckinSkeleton />
      ) : (
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <IconButton
              sx={{ backgroundColor: "#3D3D3D4D" }}
              onClick={() => {
                navigate(`/front-desk-kiosk/${hotelId}`);
                // window.history.back();
              }}
            >
              <HomeIcon
                sx={{ color: "#FFFFFF", fontSize: 24, strokeWidth: 2 }}
              />
            </IconButton>
          </Box>

          <Box
            sx={{
              mt: 5,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
            }}
          >
            <Box>
              <EventNoteIcon sx={{ color: "#FFFFFF", fontSize: 100 }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: 24, fontWeight: 400 }}>
                Your booking is modified
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              <Card sx={{ backgroundColor: "#3D3D3D4D", borderRadius: "20px" }}>
                <CardHeader
                  title={
                    <Typography sx={{ fontSize: 18 }}>Stay dates</Typography>
                  }
                ></CardHeader>
                <CardContent>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 1,
                      }}
                    >
                      <Box>
                        <Typography sx={{ fontSize: 16 }} gutterBottom>
                          Check-in
                        </Typography>
                        <Typography
                          sx={{ fontWeight: 600, fontSize: 16 }}
                          // color="text.secondary"
                        >
                          {dateFormat(location?.state?.response?.checkin)}{" "}
                          <br />
                          {timeFormat(location?.state?.response?.checkin)}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography sx={{ fontSize: 16 }} gutterBottom>
                          Check-out
                        </Typography>
                        <Typography
                          sx={{ fontWeight: 600, fontSize: 16 }}
                          // color="text.secondary"
                        >
                          {dateFormat(location?.state?.response?.checkout)}{" "}
                          <br />
                          {timeFormat(location?.state?.response?.checkout)}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
            <Box sx={{ width: "100%" }}>
              <Card
                sx={{
                  backgroundColor: "#3D3D3D4D",
                  borderRadius: "20px",
                  p: "12px",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    sx={{ fontSize: 16, fontWeight: 400 }}
                    color="text.secondary"
                  >
                    Amount
                  </Typography>
                  <Typography sx={{ fontSize: 18, fontWeight: 400 }}>
                    {currencySymbol}{" "}
                    {location?.state?.response?.editCost?.toFixed(2)}
                  </Typography>
                </Box>
              </Card>
            </Box>

            {/* Footer with Proceed Button */}
            <Footer>
              {summaryDataApi?.payment_info?.balance_due > 0 &&
              (HotelData?.hotelInfo?.country === "India" ||
                HotelData?.hotelInfo?.pg_account_id) ? (
                <Button
                  fullWidth
                  variant="light-button"
                  onClick={handleSettleDues}
                  disabled={homePageDataLoading || summaryDataApiLoading}
                >
                  Proceed to pay
                </Button>
              ) : (
                <Button
                  variant="light-button"
                  sx={{ width: "100%" }}
                  onClick={() =>
                    navigate(
                      `/${HomepageData?.booking?.bookingId?.split("_")?.[1]}${
                        HomepageData?.booking?.bookingId?.split("_")?.[2]
                      }/${localStorage.getItem("bookingHash")}`
                    )
                  }
                >
                  <HomeIcon />
                  Back to Homepage
                </Button>
              )}
            </Footer>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ModifyBookingStatus;
